export default __webpack_public_path__ + "static/media/photo10.dd2700c9.jpg";